"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFindPosLc = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faXmark_1 = require("@fortawesome/pro-regular-svg-icons/faXmark");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var Autocomplete_1 = require("@mui/material/Autocomplete");
var escapeRegExp_1 = __importDefault(require("lodash/escapeRegExp"));
var throttle_1 = __importDefault(require("lodash/throttle"));
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/IconButton"));
var Icon_1 = __importDefault(require("atomicComponents/atoms/Icons/Icon"));
var AutocompletePopover_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/AutocompletePopover"));
var MultiselectTextfield_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/MultiselectTextfield"));
var Placeholder_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/Placeholder"));
var AutocompleteButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/AutocompleteButton"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var MultiSelect_1 = require("../MultiSelect");
var makeFindPosLc = function (searchStr) {
    if (!searchStr)
        return function () { return 0; };
    var searchStrLc = searchStr.toLowerCase();
    var atBeginningOfWord = new RegExp("\\b".concat((0, escapeRegExp_1.default)(searchStrLc)));
    return function (targetStr) {
        var targetStrLc = targetStr.toLowerCase();
        return (targetStrLc.match(atBeginningOfWord) ? 0 : 100000) + targetStrLc.indexOf(searchStr.toLowerCase());
    };
};
exports.makeFindPosLc = makeFindPosLc;
var Autocomplete = function (_a) {
    var _b = _a.input, name = _b.name, defaultValue = _b.value, onChange = _b.onChange, onBlur = _b.onBlur, restFormInputProps = __rest(_b, ["name", "value", "onChange", "onBlur"]), label = _a.label, options = _a.options, placeholder = _a.placeholder, isDisabled = _a.isDisabled, onCreate = _a.onCreate, btnProps = _a.btnProps, elementRef = _a.elementRef, loadOnChange = _a.loadOnChange, endAdornment = _a.endAdornment, rest = __rest(_a, ["input", "label", "options", "placeholder", "isDisabled", "onCreate", "btnProps", "elementRef", "loadOnChange", "endAdornment"]);
    var _c = __read(react_1.default.useState((elementRef === null || elementRef === void 0 ? void 0 : elementRef.elmRef) || null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = __read(react_1.default.useState(defaultValue || null), 2), value = _d[0], setValue = _d[1];
    var divRef = react_1.default.useRef(null);
    var handleClose = (0, throttle_1.default)(function () {
        if (anchorEl) {
            anchorEl.focus();
        }
        var newValue = onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
        if (newValue) {
            if (newValue instanceof Promise)
                newValue.then(function (nV) { return setValue(nV); });
            else
                setValue(newValue);
        }
        setAnchorEl(null);
        elementRef === null || elementRef === void 0 ? void 0 : elementRef.setElmRef(null);
    }, 500, { leading: true, trailing: false });
    var filter = (0, Autocomplete_1.createFilterOptions)();
    var filterOptions = function (opts, params) {
        var inputValue = params.inputValue;
        var filtered = filter(opts, params);
        var findPosLc = (0, exports.makeFindPosLc)(inputValue);
        filtered.sort(function (v1, v2) { return (findPosLc(v1.label) - findPosLc(v2.label)) * 2 + v1.label.localeCompare(v2.label); });
        // Suggest the creation of a new value
        var isExisting = opts === null || opts === void 0 ? void 0 : opts.some(function (option) { return inputValue === option.label; });
        var filteredWithoutSelected = filtered.filter(function (opt) { return opt.value !== (value === null || value === void 0 ? void 0 : value.value); });
        var filteredAndLimited = inputValue.length < 3 ? filteredWithoutSelected.slice(0, 20) : filteredWithoutSelected;
        if (inputValue !== '' && !isExisting && onCreate) {
            filteredAndLimited.push({ label: inputValue, value: inputValue, isNew: true });
        }
        return filteredAndLimited;
    };
    var handleInputChange = function (event, newValue) {
        if (newValue && newValue.isNew) {
            if (onCreate) {
                setValue(newValue || null);
                onCreate(newValue);
                return; // breaks function
            }
        }
        setValue(newValue || null);
        if (onChange)
            onChange(newValue || null);
        setAnchorEl(null);
        elementRef === null || elementRef === void 0 ? void 0 : elementRef.setElmRef(null);
    };
    var handleOnClear = function (e) {
        if (btnProps === null || btnProps === void 0 ? void 0 : btnProps.onClear)
            btnProps.onClear(e);
        setValue(null);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { ref: divRef, component: "span", mt: -7 }), !elementRef && ((0, jsx_runtime_1.jsx)(AutocompleteButton_1.default, __assign({}, btnProps, { disabled: isDisabled, onClick: function () { return setAnchorEl(divRef.current); }, endIcon: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.withCaret) ? (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: anchorEl ? pro_solid_svg_icons_1.faCaretUp : pro_solid_svg_icons_1.faCaretDown }) : undefined, isPlaceholder: !(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 2, width: 1, justifyContent: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.onClear) && defaultValue ? 'space-between' : 'flex-start' }, { children: [(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label) ? (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: defaultValue.label }) : label, ((btnProps === null || btnProps === void 0 ? void 0 : btnProps.onClear) && defaultValue && !isDisabled) && ((0, jsx_runtime_1.jsx)(IconButton_1.default, { onClick: function (e) { return handleOnClear(e); }, icon: faXmark_1.faXmark, size: "small", neutralByDefault: true, color: "primary", isCircle: true, className: "showOnHover" }))] })) }))), (0, jsx_runtime_1.jsx)(AutocompletePopover_1.default, __assign({ open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose }, { children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, __assign({}, rest, { open: true, options: options, filterOptions: filterOptions, forcePopupIcon: false, color: "primary", disabled: isDisabled, getOptionDisabled: function () { return isDisabled || false; }, getOptionLabel: function (option) { return "".concat(option.isNew ? 'Create ' : '').concat(option.label); }, PopperComponent: MultiSelect_1.PopperComponent, renderInput: function (_a) {
                        var InputProps = _a.InputProps, props = __rest(_a, ["InputProps"]);
                        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MultiselectTextfield_1.default, __assign({}, props, restFormInputProps, { color: "primary", name: name, InputProps: __assign(__assign({}, InputProps), { endAdornment: (InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment) || endAdornment
                                            ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [endAdornment && (0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "end" }, { children: endAdornment })), InputProps.endAdornment] })
                                            : undefined }) })), (0, jsx_runtime_1.jsx)(Placeholder_1.default, { children: placeholder || label })] }));
                    }, onChange: function (event, newValue) { handleInputChange(event, newValue); } })) }))] }));
};
exports.default = react_1.default.memo(Autocomplete);
